// extracted by mini-css-extract-plugin
module.exports = {"bulletin":"BulletinEditorSlate_bulletin__1Nlx1"};